/* esm.sh - @radix-ui/react-hover-card@1.1.15 */
export * from "/*@radix-ui/react-hover-card@1.1.15/esnext/react-hover-card.mjs";
